import { css } from 'linaria';
import { styled } from 'linaria/react';

export const faqItemStyles = css`
	&:first-of-type {
		margin-top: 24px;
	}

	&:not(:first-of-type):not(:last-of-type) {
		border-radius: 0;
	}
`;
export const OrderedList = styled.ol`
	padding-left: 20px;
`;
export const UnorderedList = styled.ul`
	padding-left: 14px;
	margin-top: 16px;
	margin-bottom: 16px;
`;
export const UnorderedListItem = styled.li`
	padding-left: 10px;
`;
export const FaqSection = styled.section`
	margin-top: 80px;
`;
